import {useState} from 'react';
import Alert from '../../components/layout/Alert';
import Spinner from '../../components/button/Spinner';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import axios from 'axios';

const Reset = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertColor, setAlertColor] = useState(null);
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const api = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL
    });

    const handleSubmit = () => {
        if (password !== confirmPassword) {
            setAlertColor('red');
            setAlertMessage('As senhas não são iguais');
            setShowAlert(true);
            return;
        }
        const token = searchParams.get('token');
        if (token === null) {
            setAlertColor('red');
            setAlertMessage('Token não enviado');
            setShowAlert(true);
            return;
        }
        setLoading(true);
        setShowAlert(false);
        api
            .post('password/reset', {
                    password: password,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                }
            )
            .then(() => {
                setAlertColor('blue')
                setAlertMessage('Senha alterada com sucesso');
                setShowAlert(true);
                setPassword('');
                setConfirmPassword('');
            })
            .catch((err) => {
                setShowAlert(true);
                setAlertColor('red');
                if (err.response.status) {
                    if (err.response.status !== 500) {
                        if (err.response.data.errors) {
                            const errors = err.response.data.errors;
                            setAlertMessage(errors[Object.keys(errors)[0]][0]);
                        } else {
                            setAlertMessage(err.response.data.message);
                        }

                        return;
                    }
                }
                setAlertMessage('Erro ao enviar dados');
                console.error(err);
            })
            .finally(() => setLoading(false));
    };

    return (
        <>
            <div className="m-auto bg-white rounded-md content-center w-full space-y-8 text-center">
                <form
                    className="content-center space-y-5 pt-7"
                    method="POST"
                    onSubmit={function (e) {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >
              <span className="text-zinc-600 text-3xl font-semibold">
                Cadastrar Senha
              </span>
                    <div className="rounded-md shadow-sm">
                        <input
                            id="password"
                            name="password"
                            type="password"
                            value={password}
                            autoComplete="current-password"
                            minLength="6"
                            required
                            className="mb-5 appearance-none w-3/4 px-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder="Senha"
                            onChange={(e) => {
                                setPassword(e.currentTarget.value);
                            }}
                        />

                        <input
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            minLength="6"
                            value={confirmPassword}
                            autoComplete="current-confirmPassword"
                            required
                            className="appearance-none w-3/4 px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder="Repetir senha"
                            onChange={(e) => {
                                setConfirmPassword(e.currentTarget.value);
                            }}
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-blue-500 font-bold text-white  relative
                             w-3/4 flex justify-center py-2 px-4 border border-transparent text-sm
                             font-medium rounded-md  hover:bg-blue-600 focus:outline-none focus:ring-2
                             focus:ring-offset-2 focus:ring-indigo-500 m-auto"
                    >
                        <span className="absolute left-0 inset-y-0 flex items-center pl-3"/>
                        Cadastrar
                    </button>
                    <Alert
                        alertOpen={setShowAlert}
                        show={showAlert}
                        color={alertColor}
                        message={alertMessage}
                    />
                    <Spinner loading={loading}/>
                    <Link to="/" onClick={(e) => {
                        e.preventDefault();
                        navigate('/');
                    }}
                          className="block underline font-medium text-blue-500 hover:text-blue-900 pb-7">
                        Voltar
                    </Link>
                </form>
            </div>
        </>
    );
};
export default Reset;
